import React, { Component } from 'react'
import PropTypes from 'prop-types'
import UnorderedListIcon from 'material-ui/svg-icons/editor/format-list-bulleted'
import OrderedListIcon from 'material-ui/svg-icons/editor/format-list-numbered'
import BlockStyleButton from './BlockStyleButton'
import css from './styles.css'

const BLOCK_TEXT_TYPES = [
  { label: 'huge', icon: null, style: 'header-two' },
  { label: 'bigger', icon: null, style: 'header-three' },
  { label: 'big', icon: null, style: 'header-four' },
  { label: 'normal', icon: null, style: 'unstyled' },
  { label: 'small', icon: null, style: 'header-six' },
  { label: 'Blockquote', icon: null, style: 'blockquote' },
]

const SET_OF_BLOCK_TEXT_TYPES = new Set(BLOCK_TEXT_TYPES.map(t => t.style))

const BLOCK_LIST_TYPES = [
  { label: 'UL', icon: UnorderedListIcon, style: 'unordered-list-item' },
  { label: 'OL', icon: OrderedListIcon, style: 'ordered-list-item' },
]

class BlockStyleControls extends Component {
  static propTypes = {
    editorState: PropTypes.object.isRequired,
    onToggle: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = { blockType: '' }
  }

  componentWillReceiveProps(nextProps) {
    const { editorState } = nextProps
    const selection = editorState.getSelection()
    const blockType = editorState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey())
      .getType()

    if (SET_OF_BLOCK_TEXT_TYPES.has(blockType)) {
      this.setState({ blockType })
    } else {
      this.setState({ blockType: 'unstyled' })
    }
  }

  handleSelect = (ev) => {
    ev.preventDefault()
    this.props.onToggle(ev.target.value)
  }

  render() {
    const { blockType } = this.state

    return (
      <div className={css.blockStyleControls}>
        <select
          className={css.dropdown}
          value={blockType}
          onChange={this.handleSelect}
        >
          {BLOCK_TEXT_TYPES.map(type =>
            (<option key={type.label} value={type.style}>{type.label}</option>),
          )}
        </select>
        {BLOCK_LIST_TYPES.map(type =>
          (<BlockStyleButton
            key={type.label}
            isActive={type.style === blockType}
            label={type.label}
            onToggle={this.props.onToggle}
            style={type.style}
            icon={type.icon}
          />),
        )}
      </div>
    )
  }
}

export default BlockStyleControls



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/StyleControls/BlockStyleControls.js